import jQuery from 'jquery'

import SimpleBar from 'simplebar' // or "import SimpleBar from 'simplebar';" if you want to use it manually.
// import 'simplebar/dist/simplebar.css';
// Import jQuery => utilise celui de wp de base, evite duplicat de jquery
// import jQuery from "jquery";
// export for others scripts to use
window.$ = window.jQuery = jQuery

// Import Slick
import 'slick-carousel'

// Require modules
import browserClassHelpers from './modules/browser-class-helpers.js'
import header from './modules/header.js'
import materialForm from './modules/material-form.js'
import navScrollHighlight from './modules/nav-scroll-highlight.js'
import confidentialDoc from './modules/confidentialDoc.js'
import scrollAnchor from './modules/scroll-anchor.js'
import ssTooltip from './modules/tooltip'
import shareLinks from './modules/shareLinks'
import block_mediaText from './modules/mediaText'
import block_keyNumbers from './modules/keyNumbers'
import block_news from './modules/news'
import block_team from './modules/team'
import block_testimonials from './modules/testimonials'
import stickyFrise from './modules/sticky-frise'
import BlockPartners from './modules/block-partners'
import BlockMap from './modules/block-map'
import BlockFaq from './modules/block-faq'
import BlockFullTeam from './modules/block-full-team'
import scrollToFirstBlock from './modules/scroll-to-first-block'
import b17PushJobOffer from './modules/b17-push-job-offer'
import t10Faq from './modules/t10-faq'
import pushSarbacane from './modules/push-sarbacane'

jQuery.event.special.touchstart = {
    setup: function( _, ns, handle ) {
        this.addEventListener("touchstart", handle, { passive: !ns.includes("noPreventDefault") });
    }
};
jQuery.event.special.touchmove = {
    setup: function( _, ns, handle ) {
        this.addEventListener("touchmove", handle, { passive: !ns.includes("noPreventDefault") });
    }
};
jQuery.event.special.wheel = {
    setup: function( _, ns, handle ){
        this.addEventListener("wheel", handle, { passive: true });
    }
};
jQuery.event.special.mousewheel = {
    setup: function( _, ns, handle ){
        this.addEventListener("mousewheel", handle, { passive: true });
    }
};

$(function () {
    $('html').removeClass('no-js')

    // function checkMouse() {
    //   if (isTouchDevice()) {
    //     document.body.classList.remove('has-mouse')
    //   }else{
    //     document.body.classList.add('has-mouse')
    //   }
    // }
    // window.addEventListener('resize', ()=>{
    //   checkMouse()
    // })
    // checkMouse()

    browserClassHelpers.init()

    header.init()

    shareLinks.init()

    if (document.querySelectorAll('.js-simple-scrollbar').length > 0) {
        document.querySelectorAll('.js-simple-scrollbar').forEach((el) => {
            let options = {
                autoHide: false,
                scrollbarMinSize: 45,
                scrollbarMaxSize: 45,
            }
            let type = el.CDATA_SECTION_NODE.scrollbar
            if (type === 'vertical') {}
            const scrollbar = new SimpleBar(el, options)
        })
    }

    if ($('.materialForm').length) {
        materialForm.init()
    }
    if ($('.js-scroll-anchor').length) {
        scrollAnchor.init()
    }
    if ($('.js-nav-link').length) {
        navScrollHighlight.init()
    }
    if ($('.js-confidential-document').length) {
        confidentialDoc.init()
    }
    if ($('.js-tooltip').length) {
        ssTooltip.init()
    }
    if ($('.js-mediaText-slider').length) {
        block_mediaText.init()
    }

    if ($('.js-scrollToFirstBlock').length) {
        scrollToFirstBlock.init()
    }

    if ($('.js-pushJobOffer-loadMore').length) {
        b17PushJobOffer.init()
    }

    // pour les slider ne pas oublier le init ici
    if ($('.js-news-slider').length) {
        block_news.init()
    }

    if ($('.js-keynumber-slider').length) {
        block_keyNumbers.init()
    }

    if ($('.js-faqFilter-slider').length) {
        t10Faq.init()
    }

    if ($('.js-testimonials-slider').length) {
        block_testimonials.init()
    }

    if ($('.js-push-sarbacane').length) {
        pushSarbacane.init()
    }

    if ($('.js-team').length) {
        block_team.init()
    }
    // if (document.querySelectorAll('.js-team').length > 0) {
    //   document.querySelectorAll('.js-team').forEach((el) => {
    //     new BlockTeam(el)
    //   })
    // }

    if (document.querySelector('.js-frise')) {
        stickyFrise.init(document.querySelector('.js-frise'))
    }

    if (document.querySelectorAll('.js-partners').length > 0) {
        document.querySelectorAll('.js-partners').forEach((el) => {
            new BlockPartners(el)
        })
    }

    if (document.querySelectorAll('.js-map').length > 0) {
        document.querySelectorAll('.js-map').forEach((el) => {
            new BlockMap(el)
        })
    }

    if (document.querySelectorAll('.js-faq').length > 0) {
        document.querySelectorAll('.js-faq').forEach((el) => {
            new BlockFaq(el)
        })
    }

    if (document.querySelectorAll('.js-fullTeam').length > 0) {
        document.querySelectorAll('.js-fullTeam').forEach((el) => {
            new BlockFullTeam(el)
        })
    }

    $('.js-toggle-trigger').click(function(e){
        e.preventDefault();
        let $this = $(this)
        let $target = $($this.attr('data-toggle-target'));
        if($target && $target.length >0){
            if($this.hasClass('active')){
                $this.removeClass("active");
                $target.slideUp();
            }else{
                $this.addClass("active");
                $target.hide().removeClass('visuallyHidden').slideDown();
            }
        }
    })

    $(".form__group--address").each(function(){
        let $form__groupAddress = $(this);
        $form__groupAddress.find('.gform-grid-col').each(function(){
            let $gformGridCol = $(this);
            let $label = $gformGridCol.find("label");
            let $input = $gformGridCol.find("input");
            let $select = $gformGridCol.find("select");
            if($input.length){
                $input.attr("placeholder", $label.text())
                $label.hide();
            }
            if($select.length){
                $select.find("option[value='']").text($label.text())
                $label.hide();
            }

        });
    });
})

function isTouchDevice() {
    return (
        'ontouchstart' in window ||
        navigator.maxTouchPoints > 0 ||
        navigator.msMaxTouchPoints > 0
    )
}
